import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {ImagesLoaderService} from '../services/images-loader.service';

export const loadImagesGuard: CanActivateFn = (): boolean => {
  const imagesLoader: ImagesLoaderService = inject(ImagesLoaderService);

  imagesLoader.loadImages();

  return true;
};
